/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Reside Document
 * Reside document micro-service
 *
 * OpenAPI spec version: 0.0.1
 * Contact: peter.sokolik@thinkcreatix.com
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */
import * as url from "url";
import * as portableFetch from "portable-fetch";
const BASE_PATH = "//localhost:8083/".replace(/\/+$/, "");
/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    constructor(configuration, basePath = BASE_PATH, fetch = portableFetch) {
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
    }
}
/**
 * @export
 * @namespace Admission
 */
export var Admission;
(function (Admission) {
    /**
     * @export
     * @enum {string}
     */
    let StatusEnum;
    (function (StatusEnum) {
        StatusEnum["PRE_FLIGHT"] = "PRE_FLIGHT";
        StatusEnum["CANCELLED"] = "CANCELLED";
        StatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
        StatusEnum["SIGNED"] = "SIGNED";
        StatusEnum["APPROVED"] = "APPROVED";
        StatusEnum["ARCHIVED"] = "ARCHIVED";
        StatusEnum["INCOMPLETE"] = "INCOMPLETE";
    })(StatusEnum = Admission.StatusEnum || (Admission.StatusEnum = {}));
})(Admission || (Admission = {}));
/**
 * @export
 * @namespace AdmissionFileReference
 */
export var AdmissionFileReference;
(function (AdmissionFileReference) {
    /**
     * @export
     * @enum {string}
     */
    let PccUploadStatusEnum;
    (function (PccUploadStatusEnum) {
        PccUploadStatusEnum["SUCCESS"] = "SUCCESS";
        PccUploadStatusEnum["PENDING"] = "PENDING";
        PccUploadStatusEnum["ERROR"] = "ERROR";
    })(PccUploadStatusEnum = AdmissionFileReference.PccUploadStatusEnum || (AdmissionFileReference.PccUploadStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    let TypeEnum;
    (function (TypeEnum) {
        TypeEnum["ADMISSION"] = "ADMISSION";
        TypeEnum["PHOTO"] = "PHOTO";
        TypeEnum["TEMPLATE"] = "TEMPLATE";
        TypeEnum["PICTURE"] = "PICTURE";
        TypeEnum["VARIABLE"] = "VARIABLE";
        TypeEnum["ANSWER"] = "ANSWER";
        TypeEnum["PROTECTED"] = "PROTECTED";
        TypeEnum["USER_IMPORT"] = "USER_IMPORT";
        TypeEnum["USER_EXPORT"] = "USER_EXPORT";
    })(TypeEnum = AdmissionFileReference.TypeEnum || (AdmissionFileReference.TypeEnum = {}));
})(AdmissionFileReference || (AdmissionFileReference = {}));
/**
 * @export
 * @namespace AdmissionNote
 */
export var AdmissionNote;
(function (AdmissionNote) {
    /**
     * @export
     * @enum {string}
     */
    let StatusEnum;
    (function (StatusEnum) {
        StatusEnum["NEW"] = "NEW";
        StatusEnum["RESOLVED"] = "RESOLVED";
        StatusEnum["CANCELLED"] = "CANCELLED";
    })(StatusEnum = AdmissionNote.StatusEnum || (AdmissionNote.StatusEnum = {}));
})(AdmissionNote || (AdmissionNote = {}));
/**
 * @export
 * @namespace AnswerOfobject
 */
export var AnswerOfobject;
(function (AnswerOfobject) {
    /**
     * @export
     * @enum {string}
     */
    let QuestionTypeEnum;
    (function (QuestionTypeEnum) {
        QuestionTypeEnum["TEXT"] = "TEXT";
        QuestionTypeEnum["DATE"] = "DATE";
        QuestionTypeEnum["DATETIME"] = "DATETIME";
        QuestionTypeEnum["CHECKBOX"] = "CHECKBOX";
        QuestionTypeEnum["RADIO"] = "RADIO";
        QuestionTypeEnum["SELECT"] = "SELECT";
        QuestionTypeEnum["STATE_SELECT"] = "STATE_SELECT";
        QuestionTypeEnum["SIGNATURE"] = "SIGNATURE";
        QuestionTypeEnum["IMAGE"] = "IMAGE";
        QuestionTypeEnum["TEXTAREA"] = "TEXTAREA";
        QuestionTypeEnum["OBJECT"] = "OBJECT";
        QuestionTypeEnum["LIST"] = "LIST";
        QuestionTypeEnum["FILE"] = "FILE";
        QuestionTypeEnum["CURRENCY"] = "CURRENCY";
        QuestionTypeEnum["TIMEZONE_SELECT"] = "TIMEZONE_SELECT";
    })(QuestionTypeEnum = AnswerOfobject.QuestionTypeEnum || (AnswerOfobject.QuestionTypeEnum = {}));
})(AnswerOfobject || (AnswerOfobject = {}));
/**
 * @export
 * @namespace Approval
 */
export var Approval;
(function (Approval) {
    /**
     * @export
     * @enum {string}
     */
    let ApproverTitleEnum;
    (function (ApproverTitleEnum) {
        ApproverTitleEnum["ADMISSIONS_FINANCIAL_SPECIALIST"] = "ADMISSIONS_FINANCIAL_SPECIALIST";
        ApproverTitleEnum["ADMISSIONS_DIRECTOR"] = "ADMISSIONS_DIRECTOR";
        ApproverTitleEnum["FINANCIAL_COORDINATOR"] = "FINANCIAL_COORDINATOR";
        ApproverTitleEnum["ADMINISTRATOR"] = "ADMINISTRATOR";
        ApproverTitleEnum["SOCIAL_SERVICES_DIRECTOR"] = "SOCIAL_SERVICES_DIRECTOR";
        ApproverTitleEnum["LIAISON"] = "LIAISON";
        ApproverTitleEnum["BUSINESS_OFFICE_MANAGER"] = "BUSINESS_OFFICE_MANAGER";
        ApproverTitleEnum["EXECUTIVE_DIRECTOR"] = "EXECUTIVE_DIRECTOR";
        ApproverTitleEnum["LICENSEE"] = "LICENSEE";
        ApproverTitleEnum["GENERAL_MANAGER"] = "GENERAL_MANAGER";
        ApproverTitleEnum["FACILITY_REPRESENTATIVE"] = "FACILITY_REPRESENTATIVE";
    })(ApproverTitleEnum = Approval.ApproverTitleEnum || (Approval.ApproverTitleEnum = {}));
})(Approval || (Approval = {}));
/**
 * @export
 * @namespace ChecklistItem
 */
export var ChecklistItem;
(function (ChecklistItem) {
    /**
     * @export
     * @enum {string}
     */
    let CheckedStatusEnum;
    (function (CheckedStatusEnum) {
        CheckedStatusEnum["OPEN"] = "OPEN";
        CheckedStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
        CheckedStatusEnum["COMPLETED"] = "COMPLETED";
        CheckedStatusEnum["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    })(CheckedStatusEnum = ChecklistItem.CheckedStatusEnum || (ChecklistItem.CheckedStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    let MandatoryForStatusesEnum;
    (function (MandatoryForStatusesEnum) {
        MandatoryForStatusesEnum["PRE_FLIGHT"] = "PRE_FLIGHT";
        MandatoryForStatusesEnum["CANCELLED"] = "CANCELLED";
        MandatoryForStatusesEnum["IN_PROGRESS"] = "IN_PROGRESS";
        MandatoryForStatusesEnum["SIGNED"] = "SIGNED";
        MandatoryForStatusesEnum["APPROVED"] = "APPROVED";
        MandatoryForStatusesEnum["ARCHIVED"] = "ARCHIVED";
        MandatoryForStatusesEnum["INCOMPLETE"] = "INCOMPLETE";
    })(MandatoryForStatusesEnum = ChecklistItem.MandatoryForStatusesEnum || (ChecklistItem.MandatoryForStatusesEnum = {}));
})(ChecklistItem || (ChecklistItem = {}));
/**
 * @export
 * @namespace PartialPdfReference
 */
export var PartialPdfReference;
(function (PartialPdfReference) {
    /**
     * @export
     * @enum {string}
     */
    let PccUploadStatusEnum;
    (function (PccUploadStatusEnum) {
        PccUploadStatusEnum["SUCCESS"] = "SUCCESS";
        PccUploadStatusEnum["PENDING"] = "PENDING";
        PccUploadStatusEnum["ERROR"] = "ERROR";
    })(PccUploadStatusEnum = PartialPdfReference.PccUploadStatusEnum || (PartialPdfReference.PccUploadStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    let TypeEnum;
    (function (TypeEnum) {
        TypeEnum["ADMISSION"] = "ADMISSION";
        TypeEnum["PHOTO"] = "PHOTO";
        TypeEnum["TEMPLATE"] = "TEMPLATE";
        TypeEnum["PICTURE"] = "PICTURE";
        TypeEnum["VARIABLE"] = "VARIABLE";
        TypeEnum["ANSWER"] = "ANSWER";
        TypeEnum["PROTECTED"] = "PROTECTED";
        TypeEnum["USER_IMPORT"] = "USER_IMPORT";
        TypeEnum["USER_EXPORT"] = "USER_EXPORT";
    })(TypeEnum = PartialPdfReference.TypeEnum || (PartialPdfReference.TypeEnum = {}));
})(PartialPdfReference || (PartialPdfReference = {}));
/**
 * @export
 * @namespace Pcc
 */
export var Pcc;
(function (Pcc) {
    /**
     * @export
     * @enum {string}
     */
    let RelatedAdmissionStatusEnum;
    (function (RelatedAdmissionStatusEnum) {
        RelatedAdmissionStatusEnum["PRE_FLIGHT"] = "PRE_FLIGHT";
        RelatedAdmissionStatusEnum["CANCELLED"] = "CANCELLED";
        RelatedAdmissionStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
        RelatedAdmissionStatusEnum["SIGNED"] = "SIGNED";
        RelatedAdmissionStatusEnum["APPROVED"] = "APPROVED";
        RelatedAdmissionStatusEnum["ARCHIVED"] = "ARCHIVED";
        RelatedAdmissionStatusEnum["INCOMPLETE"] = "INCOMPLETE";
    })(RelatedAdmissionStatusEnum = Pcc.RelatedAdmissionStatusEnum || (Pcc.RelatedAdmissionStatusEnum = {}));
})(Pcc || (Pcc = {}));
/**
 * @export
 * @namespace QuestionReference
 */
export var QuestionReference;
(function (QuestionReference) {
    /**
     * @export
     * @enum {string}
     */
    let TypeEnum;
    (function (TypeEnum) {
        TypeEnum["TEXT"] = "TEXT";
        TypeEnum["DATE"] = "DATE";
        TypeEnum["DATETIME"] = "DATETIME";
        TypeEnum["CHECKBOX"] = "CHECKBOX";
        TypeEnum["RADIO"] = "RADIO";
        TypeEnum["SELECT"] = "SELECT";
        TypeEnum["STATE_SELECT"] = "STATE_SELECT";
        TypeEnum["SIGNATURE"] = "SIGNATURE";
        TypeEnum["IMAGE"] = "IMAGE";
        TypeEnum["TEXTAREA"] = "TEXTAREA";
        TypeEnum["OBJECT"] = "OBJECT";
        TypeEnum["LIST"] = "LIST";
        TypeEnum["FILE"] = "FILE";
        TypeEnum["CURRENCY"] = "CURRENCY";
        TypeEnum["TIMEZONE_SELECT"] = "TIMEZONE_SELECT";
    })(TypeEnum = QuestionReference.TypeEnum || (QuestionReference.TypeEnum = {}));
})(QuestionReference || (QuestionReference = {}));
/**
 * DocumentControllerApi - fetch parameter creator
 * @export
 */
export const DocumentControllerApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Generate PDF based on given admission data and save the generated PDF into a persistent storage
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndSavePdfUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling generateAndSavePdfUsingPOST.');
            }
            const localVarPath = `/api/v3/documents/generate/save`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("Admission" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate basic rates PDF based on given admission data
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBasicRatesPdfUsingGET(accessToken, admissionId, authorization, options = {}) {
            // verify required parameter 'accessToken' is not null or undefined
            if (accessToken === null || accessToken === undefined) {
                throw new RequiredError('accessToken', 'Required parameter accessToken was null or undefined when calling generateBasicRatesPdfUsingGET.');
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError('admissionId', 'Required parameter admissionId was null or undefined when calling generateBasicRatesPdfUsingGET.');
            }
            const localVarPath = `/api/v3/documents/{admissionId}/generate/rates`
                .replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accessToken !== undefined) {
                localVarQueryParameter['accessToken'] = accessToken;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate PDF based on given admission data
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} [body] gaugeToken
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfUsingGET(accessToken, admissionId, body, authorization, options = {}) {
            // verify required parameter 'accessToken' is not null or undefined
            if (accessToken === null || accessToken === undefined) {
                throw new RequiredError('accessToken', 'Required parameter accessToken was null or undefined when calling generatePdfUsingGET.');
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError('admissionId', 'Required parameter admissionId was null or undefined when calling generatePdfUsingGET.');
            }
            const localVarPath = `/api/v3/documents/{admissionId}/generate`
                .replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accessToken !== undefined) {
                localVarQueryParameter['accessToken'] = accessToken;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = '*/*';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate PDF based on given admission data
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfUsingPOST(body, authorization, options = {}) {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling generatePdfUsingPOST.');
            }
            const localVarPath = `/api/v3/documents/generate`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("Admission" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} admissionTemplateId Identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilityPropertiesUsingGET(admissionTemplateId, authorization, options = {}) {
            // verify required parameter 'admissionTemplateId' is not null or undefined
            if (admissionTemplateId === null || admissionTemplateId === undefined) {
                throw new RequiredError('admissionTemplateId', 'Required parameter admissionTemplateId was null or undefined when calling getFacilityPropertiesUsingGET.');
            }
            const localVarPath = `/api/v3/documents/facility-properties/{admissionTemplateId}`
                .replace(`{${"admissionTemplateId"}}`, encodeURIComponent(String(admissionTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get template for facility settings
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitySettingsTemplateUsingGET(admissionTemplateId, authorization, options = {}) {
            // verify required parameter 'admissionTemplateId' is not null or undefined
            if (admissionTemplateId === null || admissionTemplateId === undefined) {
                throw new RequiredError('admissionTemplateId', 'Required parameter admissionTemplateId was null or undefined when calling getFacilitySettingsTemplateUsingGET.');
            }
            const localVarPath = `/api/v3/documents/facility-settings-template/{admissionTemplateId}`
                .replace(`{${"admissionTemplateId"}}`, encodeURIComponent(String(admissionTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get latest PDF template for given template name
         * @param {string} facilityId facilityId
         * @param {string} templateName templateName
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPdfTemplateUsingGET(facilityId, templateName, authorization, options = {}) {
            // verify required parameter 'facilityId' is not null or undefined
            if (facilityId === null || facilityId === undefined) {
                throw new RequiredError('facilityId', 'Required parameter facilityId was null or undefined when calling getLatestPdfTemplateUsingGET.');
            }
            // verify required parameter 'templateName' is not null or undefined
            if (templateName === null || templateName === undefined) {
                throw new RequiredError('templateName', 'Required parameter templateName was null or undefined when calling getLatestPdfTemplateUsingGET.');
            }
            const localVarPath = `/api/v3/documents/template/{facilityId}/{templateName}/pdf/latest`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"templateName"}}`, encodeURIComponent(String(templateName)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get latest admission document for facility
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTemplateVersionUsingGET(facilityId, authorization, options = {}) {
            // verify required parameter 'facilityId' is not null or undefined
            if (facilityId === null || facilityId === undefined) {
                throw new RequiredError('facilityId', 'Required parameter facilityId was null or undefined when calling getLatestTemplateVersionUsingGET.');
            }
            const localVarPath = `/api/v3/documents/facilities/{facilityId}/version`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Generate partial PDF template for given group key. Group key is made by replacing all non-word chars of group id with underscore.
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} groupKey groupKey
         * @param {string} [body] gaugeToken
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartialPdfUsingGET(accessToken, admissionId, groupKey, body, authorization, options = {}) {
            // verify required parameter 'accessToken' is not null or undefined
            if (accessToken === null || accessToken === undefined) {
                throw new RequiredError('accessToken', 'Required parameter accessToken was null or undefined when calling getPartialPdfUsingGET.');
            }
            // verify required parameter 'admissionId' is not null or undefined
            if (admissionId === null || admissionId === undefined) {
                throw new RequiredError('admissionId', 'Required parameter admissionId was null or undefined when calling getPartialPdfUsingGET.');
            }
            // verify required parameter 'groupKey' is not null or undefined
            if (groupKey === null || groupKey === undefined) {
                throw new RequiredError('groupKey', 'Required parameter groupKey was null or undefined when calling getPartialPdfUsingGET.');
            }
            const localVarPath = `/api/v3/documents/{admissionId}/generate/{groupKey}`
                .replace(`{${"admissionId"}}`, encodeURIComponent(String(admissionId)))
                .replace(`{${"groupKey"}}`, encodeURIComponent(String(groupKey)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (accessToken !== undefined) {
                localVarQueryParameter['accessToken'] = accessToken;
            }
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarHeaderParameter['Content-Type'] = '*/*';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get template for preflight
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreflightTemplateUsingGET(admissionTemplateId, authorization, options = {}) {
            // verify required parameter 'admissionTemplateId' is not null or undefined
            if (admissionTemplateId === null || admissionTemplateId === undefined) {
                throw new RequiredError('admissionTemplateId', 'Required parameter admissionTemplateId was null or undefined when calling getPreflightTemplateUsingGET.');
            }
            const localVarPath = `/api/v3/documents/preflight-template/{admissionTemplateId}`
                .replace(`{${"admissionTemplateId"}}`, encodeURIComponent(String(admissionTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get template for resident experience prelude
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentExperiencePreludeTemplateUsingGET(admissionTemplateId, authorization, options = {}) {
            // verify required parameter 'admissionTemplateId' is not null or undefined
            if (admissionTemplateId === null || admissionTemplateId === undefined) {
                throw new RequiredError('admissionTemplateId', 'Required parameter admissionTemplateId was null or undefined when calling getResidentExperiencePreludeTemplateUsingGET.');
            }
            const localVarPath = `/api/v3/documents/resident-experience-prelude-template/{admissionTemplateId}`
                .replace(`{${"admissionTemplateId"}}`, encodeURIComponent(String(admissionTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get template for admission version
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateUsingGET(admissionTemplateId, authorization, options = {}) {
            // verify required parameter 'admissionTemplateId' is not null or undefined
            if (admissionTemplateId === null || admissionTemplateId === undefined) {
                throw new RequiredError('admissionTemplateId', 'Required parameter admissionTemplateId was null or undefined when calling getTemplateUsingGET.');
            }
            const localVarPath = `/api/v3/documents/template/{admissionTemplateId}`
                .replace(`{${"admissionTemplateId"}}`, encodeURIComponent(String(admissionTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get admission document for facility by version id
         * @param {string} facilityId facilityId
         * @param {string} versionId versionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateVersionUsingGET(facilityId, versionId, authorization, options = {}) {
            // verify required parameter 'facilityId' is not null or undefined
            if (facilityId === null || facilityId === undefined) {
                throw new RequiredError('facilityId', 'Required parameter facilityId was null or undefined when calling getTemplateVersionUsingGET.');
            }
            // verify required parameter 'versionId' is not null or undefined
            if (versionId === null || versionId === undefined) {
                throw new RequiredError('versionId', 'Required parameter versionId was null or undefined when calling getTemplateVersionUsingGET.');
            }
            const localVarPath = `/api/v3/documents/facilities/{facilityId}/version/{versionId}`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get templates list
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplatesNamesUsingGET(authorization, options = {}) {
            const localVarPath = `/api/v3/documents/templates`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary synchronizeFacility
         * @param {string} facilityId facilityId
         * @param {string} templateName templateName
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        synchronizeFacilityUsingGET(facilityId, templateName, authorization, options = {}) {
            // verify required parameter 'facilityId' is not null or undefined
            if (facilityId === null || facilityId === undefined) {
                throw new RequiredError('facilityId', 'Required parameter facilityId was null or undefined when calling synchronizeFacilityUsingGET.');
            }
            // verify required parameter 'templateName' is not null or undefined
            if (templateName === null || templateName === undefined) {
                throw new RequiredError('templateName', 'Required parameter templateName was null or undefined when calling synchronizeFacilityUsingGET.');
            }
            const localVarPath = `/api/v3/documents/{facilityId}/{templateName}/synchronize`
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)))
                .replace(`{${"templateName"}}`, encodeURIComponent(String(templateName)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocumentControllerApi - functional programming interface
 * @export
 */
export const DocumentControllerApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Generate PDF based on given admission data and save the generated PDF into a persistent storage
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndSavePdfUsingPOST(body, authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).generateAndSavePdfUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Generate basic rates PDF based on given admission data
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBasicRatesPdfUsingGET(accessToken, admissionId, authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).generateBasicRatesPdfUsingGET(accessToken, admissionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Generate PDF based on given admission data
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} [body] gaugeToken
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfUsingGET(accessToken, admissionId, body, authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).generatePdfUsingGET(accessToken, admissionId, body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Generate PDF based on given admission data
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfUsingPOST(body, authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).generatePdfUsingPOST(body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} admissionTemplateId Identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilityPropertiesUsingGET(admissionTemplateId, authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).getFacilityPropertiesUsingGET(admissionTemplateId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get template for facility settings
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitySettingsTemplateUsingGET(admissionTemplateId, authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).getFacilitySettingsTemplateUsingGET(admissionTemplateId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get latest PDF template for given template name
         * @param {string} facilityId facilityId
         * @param {string} templateName templateName
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPdfTemplateUsingGET(facilityId, templateName, authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).getLatestPdfTemplateUsingGET(facilityId, templateName, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get latest admission document for facility
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTemplateVersionUsingGET(facilityId, authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).getLatestTemplateVersionUsingGET(facilityId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Generate partial PDF template for given group key. Group key is made by replacing all non-word chars of group id with underscore.
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} groupKey groupKey
         * @param {string} [body] gaugeToken
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartialPdfUsingGET(accessToken, admissionId, groupKey, body, authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).getPartialPdfUsingGET(accessToken, admissionId, groupKey, body, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get template for preflight
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreflightTemplateUsingGET(admissionTemplateId, authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).getPreflightTemplateUsingGET(admissionTemplateId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get template for resident experience prelude
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentExperiencePreludeTemplateUsingGET(admissionTemplateId, authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).getResidentExperiencePreludeTemplateUsingGET(admissionTemplateId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get template for admission version
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateUsingGET(admissionTemplateId, authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).getTemplateUsingGET(admissionTemplateId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get admission document for facility by version id
         * @param {string} facilityId facilityId
         * @param {string} versionId versionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateVersionUsingGET(facilityId, versionId, authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).getTemplateVersionUsingGET(facilityId, versionId, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Get templates list
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplatesNamesUsingGET(authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).getTemplatesNamesUsingGET(authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json().then(data => ({ ...response, data }));
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary synchronizeFacility
         * @param {string} facilityId facilityId
         * @param {string} templateName templateName
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        synchronizeFacilityUsingGET(facilityId, templateName, authorization, options) {
            const localVarFetchArgs = DocumentControllerApiFetchParamCreator(configuration).synchronizeFacilityUsingGET(facilityId, templateName, authorization, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * DocumentControllerApi - factory interface
 * @export
 */
export const DocumentControllerApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Generate PDF based on given admission data and save the generated PDF into a persistent storage
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndSavePdfUsingPOST(body, authorization, options) {
            return DocumentControllerApiFp(configuration).generateAndSavePdfUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Generate basic rates PDF based on given admission data
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBasicRatesPdfUsingGET(accessToken, admissionId, authorization, options) {
            return DocumentControllerApiFp(configuration).generateBasicRatesPdfUsingGET(accessToken, admissionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Generate PDF based on given admission data
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} [body] gaugeToken
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfUsingGET(accessToken, admissionId, body, authorization, options) {
            return DocumentControllerApiFp(configuration).generatePdfUsingGET(accessToken, admissionId, body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Generate PDF based on given admission data
         * @param {Admission} body admission
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePdfUsingPOST(body, authorization, options) {
            return DocumentControllerApiFp(configuration).generatePdfUsingPOST(body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} admissionTemplateId Identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilityPropertiesUsingGET(admissionTemplateId, authorization, options) {
            return DocumentControllerApiFp(configuration).getFacilityPropertiesUsingGET(admissionTemplateId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get template for facility settings
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFacilitySettingsTemplateUsingGET(admissionTemplateId, authorization, options) {
            return DocumentControllerApiFp(configuration).getFacilitySettingsTemplateUsingGET(admissionTemplateId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get latest PDF template for given template name
         * @param {string} facilityId facilityId
         * @param {string} templateName templateName
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPdfTemplateUsingGET(facilityId, templateName, authorization, options) {
            return DocumentControllerApiFp(configuration).getLatestPdfTemplateUsingGET(facilityId, templateName, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get latest admission document for facility
         * @param {string} facilityId facilityId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestTemplateVersionUsingGET(facilityId, authorization, options) {
            return DocumentControllerApiFp(configuration).getLatestTemplateVersionUsingGET(facilityId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Generate partial PDF template for given group key. Group key is made by replacing all non-word chars of group id with underscore.
         * @param {string} accessToken accessToken
         * @param {string} admissionId admissionId
         * @param {string} groupKey groupKey
         * @param {string} [body] gaugeToken
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartialPdfUsingGET(accessToken, admissionId, groupKey, body, authorization, options) {
            return DocumentControllerApiFp(configuration).getPartialPdfUsingGET(accessToken, admissionId, groupKey, body, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get template for preflight
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreflightTemplateUsingGET(admissionTemplateId, authorization, options) {
            return DocumentControllerApiFp(configuration).getPreflightTemplateUsingGET(admissionTemplateId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get template for resident experience prelude
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResidentExperiencePreludeTemplateUsingGET(admissionTemplateId, authorization, options) {
            return DocumentControllerApiFp(configuration).getResidentExperiencePreludeTemplateUsingGET(admissionTemplateId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get template for admission version
         * @param {string} admissionTemplateId identifier of admission&#x27;s template
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateUsingGET(admissionTemplateId, authorization, options) {
            return DocumentControllerApiFp(configuration).getTemplateUsingGET(admissionTemplateId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get admission document for facility by version id
         * @param {string} facilityId facilityId
         * @param {string} versionId versionId
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplateVersionUsingGET(facilityId, versionId, authorization, options) {
            return DocumentControllerApiFp(configuration).getTemplateVersionUsingGET(facilityId, versionId, authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary Get templates list
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplatesNamesUsingGET(authorization, options) {
            return DocumentControllerApiFp(configuration).getTemplatesNamesUsingGET(authorization, options)(fetch, basePath);
        },
        /**
         *
         * @summary synchronizeFacility
         * @param {string} facilityId facilityId
         * @param {string} templateName templateName
         * @param {string} [authorization] Authorization Header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        synchronizeFacilityUsingGET(facilityId, templateName, authorization, options) {
            return DocumentControllerApiFp(configuration).synchronizeFacilityUsingGET(facilityId, templateName, authorization, options)(fetch, basePath);
        },
    };
};
/**
 * DocumentControllerApi - object-oriented interface
 * @export
 * @class DocumentControllerApi
 * @extends {BaseAPI}
 */
export class DocumentControllerApi extends BaseAPI {
    /**
     *
     * @summary Generate PDF based on given admission data and save the generated PDF into a persistent storage
     * @param {Admission} body admission
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    generateAndSavePdfUsingPOST(body, authorization, options) {
        return DocumentControllerApiFp(this.configuration).generateAndSavePdfUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Generate basic rates PDF based on given admission data
     * @param {string} accessToken accessToken
     * @param {string} admissionId admissionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    generateBasicRatesPdfUsingGET(accessToken, admissionId, authorization, options) {
        return DocumentControllerApiFp(this.configuration).generateBasicRatesPdfUsingGET(accessToken, admissionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Generate PDF based on given admission data
     * @param {string} accessToken accessToken
     * @param {string} admissionId admissionId
     * @param {string} [body] gaugeToken
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    generatePdfUsingGET(accessToken, admissionId, body, authorization, options) {
        return DocumentControllerApiFp(this.configuration).generatePdfUsingGET(accessToken, admissionId, body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Generate PDF based on given admission data
     * @param {Admission} body admission
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    generatePdfUsingPOST(body, authorization, options) {
        return DocumentControllerApiFp(this.configuration).generatePdfUsingPOST(body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} admissionTemplateId Identifier of admission&#x27;s template
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getFacilityPropertiesUsingGET(admissionTemplateId, authorization, options) {
        return DocumentControllerApiFp(this.configuration).getFacilityPropertiesUsingGET(admissionTemplateId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get template for facility settings
     * @param {string} admissionTemplateId identifier of admission&#x27;s template
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getFacilitySettingsTemplateUsingGET(admissionTemplateId, authorization, options) {
        return DocumentControllerApiFp(this.configuration).getFacilitySettingsTemplateUsingGET(admissionTemplateId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get latest PDF template for given template name
     * @param {string} facilityId facilityId
     * @param {string} templateName templateName
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getLatestPdfTemplateUsingGET(facilityId, templateName, authorization, options) {
        return DocumentControllerApiFp(this.configuration).getLatestPdfTemplateUsingGET(facilityId, templateName, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get latest admission document for facility
     * @param {string} facilityId facilityId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getLatestTemplateVersionUsingGET(facilityId, authorization, options) {
        return DocumentControllerApiFp(this.configuration).getLatestTemplateVersionUsingGET(facilityId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Generate partial PDF template for given group key. Group key is made by replacing all non-word chars of group id with underscore.
     * @param {string} accessToken accessToken
     * @param {string} admissionId admissionId
     * @param {string} groupKey groupKey
     * @param {string} [body] gaugeToken
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getPartialPdfUsingGET(accessToken, admissionId, groupKey, body, authorization, options) {
        return DocumentControllerApiFp(this.configuration).getPartialPdfUsingGET(accessToken, admissionId, groupKey, body, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get template for preflight
     * @param {string} admissionTemplateId identifier of admission&#x27;s template
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getPreflightTemplateUsingGET(admissionTemplateId, authorization, options) {
        return DocumentControllerApiFp(this.configuration).getPreflightTemplateUsingGET(admissionTemplateId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get template for resident experience prelude
     * @param {string} admissionTemplateId identifier of admission&#x27;s template
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getResidentExperiencePreludeTemplateUsingGET(admissionTemplateId, authorization, options) {
        return DocumentControllerApiFp(this.configuration).getResidentExperiencePreludeTemplateUsingGET(admissionTemplateId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get template for admission version
     * @param {string} admissionTemplateId identifier of admission&#x27;s template
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getTemplateUsingGET(admissionTemplateId, authorization, options) {
        return DocumentControllerApiFp(this.configuration).getTemplateUsingGET(admissionTemplateId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get admission document for facility by version id
     * @param {string} facilityId facilityId
     * @param {string} versionId versionId
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getTemplateVersionUsingGET(facilityId, versionId, authorization, options) {
        return DocumentControllerApiFp(this.configuration).getTemplateVersionUsingGET(facilityId, versionId, authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Get templates list
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    getTemplatesNamesUsingGET(authorization, options) {
        return DocumentControllerApiFp(this.configuration).getTemplatesNamesUsingGET(authorization, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary synchronizeFacility
     * @param {string} facilityId facilityId
     * @param {string} templateName templateName
     * @param {string} [authorization] Authorization Header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    synchronizeFacilityUsingGET(facilityId, templateName, authorization, options) {
        return DocumentControllerApiFp(this.configuration).synchronizeFacilityUsingGET(facilityId, templateName, authorization, options)(this.fetch, this.basePath);
    }
}
